<header class="groove-banner">
    <div class="container-fluid h-100">
        <section class="groove-banner__section row d-flex-center-center h-100">
            <article class="groove-banner__background" [ngStyle]="{ 'background-image': 'url(' + partner.bannerImage + ')'}"></article>
            <article class="groove-banner__content">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6"></div>
                        <div class="col-lg-6">
                            <div class="groove-banner__header mb-md-5 mb-4">
                                <fitscovery-ui-markdown-viewer [content]="getHeader()" ></fitscovery-ui-markdown-viewer>
                            </div>
                            <div class="groove-banner__description mb-md-5 mb-4">
                                <fitscovery-ui-markdown-viewer [content]="getSubHeader()" ></fitscovery-ui-markdown-viewer>
                            </div>
                            <section class="groove-banner__buttons row d-flex-center-center">
                                <button class="btn btn-primary mr-md-4 mr-0 mb-md-0 mb-4 col-lg-4 col-md-4 col-sm-6 col-10" *ngIf="partner.appConfig!.showCalendarButton" (click)="goToSchedule()">SEE OUR SCHEDULE</button>
                                <a [href]="'mailto:'+ partner.contactInfo!.email" class="btn btn-primary col-lg-4 col-md-4 col-sm-6 col-10" *ngIf="partner.appConfig!.showContactMeButton && partner.contactInfo!.email">SEND A MESSAGE</a>
                            </section>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    </div>
</header>